import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { GetCommunityGroupDocuments, GetCommunityGroupDocumentsResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";

const getData = (response?: SWRResponse<GetCommunityGroupDocumentsResponse, GetCommunityGroupDocumentsResponse>) => response?.data?.communityGroupDocuments
const getError = (response?: SWRResponse<GetCommunityGroupDocumentsResponse, GetCommunityGroupDocumentsResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetCommunityGroupDocumentsResponse, GetCommunityGroupDocumentsResponse>) => ({});

const useGetCommunityGroupDocuments = (query?: Partial<GetCommunityGroupDocuments>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetCommunityGroupDocuments(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetCommunityGroupDocuments;